import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "page-inner" }
const _hoisted_2 = { class: "stat-inner" }
const _hoisted_3 = { class: "stat-icon stat-icon-blue" }
const _hoisted_4 = { class: "stat-info" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "总提现记录", -1)
const _hoisted_6 = { class: "stat-value" }
const _hoisted_7 = { class: "stat-inner" }
const _hoisted_8 = { class: "stat-icon stat-icon-orange" }
const _hoisted_9 = { class: "stat-info" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "处理中", -1)
const _hoisted_11 = { class: "stat-value stat-value-sm" }
const _hoisted_12 = { class: "stat-inner" }
const _hoisted_13 = { class: "stat-icon stat-icon-green" }
const _hoisted_14 = { class: "stat-info" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "已打款", -1)
const _hoisted_16 = { class: "stat-value stat-value-sm" }
const _hoisted_17 = { class: "stat-inner" }
const _hoisted_18 = { class: "stat-icon stat-icon-purple" }
const _hoisted_19 = { class: "stat-info" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "已驳回", -1)
const _hoisted_21 = { class: "stat-value stat-value-sm" }
const _hoisted_22 = { class: "card-title-row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "card-title-text" }, "我的提现记录", -1)
const _hoisted_24 = {
  key: 0,
  class: "act-cell"
}
const _hoisted_25 = {
  key: 1,
  class: "act-cell"
}
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_31 = {
  key: 0,
  class: "withdrawal-card-list"
}
const _hoisted_32 = { class: "mobile-card-head" }
const _hoisted_33 = { class: "mobile-card-title" }
const _hoisted_34 = { class: "withdrawal-id" }
const _hoisted_35 = { class: "mobile-card-body" }
const _hoisted_36 = { class: "mobile-field" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "mobile-label" }, "收款方式", -1)
const _hoisted_38 = { class: "mobile-value" }
const _hoisted_39 = {
  key: 0,
  class: "mobile-field"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "mobile-label" }, "收款码", -1)
const _hoisted_41 = { class: "mobile-field" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "mobile-label" }, "备注", -1)
const _hoisted_43 = { class: "mobile-value" }
const _hoisted_44 = { class: "mobile-field" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "mobile-label" }, "处理结果", -1)
const _hoisted_46 = { class: "mobile-value" }
const _hoisted_47 = { class: "mobile-field" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", { class: "mobile-label" }, "申请时间", -1)
const _hoisted_49 = { class: "mobile-value" }
const _hoisted_50 = { class: "mobile-field" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "mobile-label" }, "处理时间", -1)
const _hoisted_52 = { class: "mobile-value" }
const _hoisted_53 = { class: "table-pagination" }
const _hoisted_54 = {
  class: "dialog-footer",
  style: {"margin-top":"16px"}
}

import { ref, computed, onMounted } from 'vue';
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { isNull } from '@/utils/publicMethods';
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils';
import { message } from 'ant-design-vue';
import axios from 'axios';
import {
    BankOutlined,
    ClockCircleOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    PlusOutlined,
    WechatOutlined,
    AlipayCircleOutlined,
} from '@ant-design/icons-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WithdrawalView',
  setup(__props) {

const baseURL = process.env.VUE_APP_API_BASE_URL;

// ============ 状态 ============
const Withdrawal_Conf = ref({
    currentPage: 1,
    pageSize: 10,
    total: 0,
});

const Withdrawal_data = ref<any[]>([]);

const tableLoading = ref(false);

const Withdrawal_Dialog = ref({
    Visible: false,
    from: {
        money: '' as any,
        skAct: [
            { act: 'wx', skm: '', str: '微信' },
            { act: 'zfb', skm: '', str: '支付宝' },
        ] as Array<{ act: string; skm: string; str: string }>,
        selectAct: '',
        remarks: '',
    },
    maxMoney: 0,
});

// ============ 统计计算 ============
const pendingCount = computed(() => {
    return Withdrawal_data.value.filter((r: any) => r.state == 0).length;
});
const successCount = computed(() => {
    return Withdrawal_data.value.filter((r: any) => r.state == 1).length;
});
const rejectedCount = computed(() => {
    return Withdrawal_data.value.filter((r: any) => r.state == -1).length;
});

// ============ 列配置 ============
const withdrawalColumns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 70, align: 'center' as const },
    { title: '提现金额', key: 'money', width: 120, align: 'right' as const },
    { title: '收款码', key: 'skm', width: 90, align: 'center' as const },
    { title: '提现方式', key: 'act', width: 100, align: 'center' as const },
    { title: '备注', dataIndex: 'remarks', key: 'remarks', ellipsis: true },
    { title: '状态', key: 'state', width: 100, align: 'center' as const },
    { title: '处理结果', dataIndex: 'res_code', key: 'res_code', width: 130 },
    { title: '申请时间', dataIndex: 'add_time', key: 'add_time', width: 160 },
    { title: '处理时间', key: 'end_time', width: 160 },
];

// ============ 业务方法 ============
const getWithdrawalAct = (act: number) => {
    switch (act) {
        case -1:
            return '提现驳回';
        case 0:
            return '等待审核';
        case 1:
            return '已打款';
        default:
            return '未知';
    }
};

const getUserWithdrawal = () => {
    tableLoading.value = true;
    openLoading();
    const data = new FormData();
    data.append('page', Withdrawal_Conf.value.currentPage);
    data.append('pageSize', Withdrawal_Conf.value.pageSize);
    const headers = {
        token: localStorage.getItem('token'),
    };

    axios
        .post(baseURL + '/userApi/getUserWithdrawal', data, { timeout: 5000, headers })
        .then((res) => {
            if (res.data.code == 200) {
                Withdrawal_data.value = res.data.data;
                Withdrawal_Conf.value.total = res.data.total;
            } else {
                message.error(res.data.msg);
            }

            if (res.data.code == 401) {
                message.error(res.data.msg);
                setTimeout(() => {
                    location.href = '/Login';
                }, 1000);
            }
        })
        .catch((err) => {
            message.error(err);
        })
        .finally(() => {
            tableLoading.value = false;
            fullscreenLoading.close();
        });
};

const getSkm = () => {
    openLoading();
    const headers = {
        token: localStorage.getItem('token'),
    };

    axios
        .post(baseURL + '/userApi/getSkm', new FormData(), { timeout: 5000, headers })
        .then((res) => {
            fullscreenLoading.close();
            if (res.data.code == 200) {
                Withdrawal_Dialog.value.from.skAct = res.data.data;
                Withdrawal_Dialog.value.maxMoney = res.data.money;
            } else if (res.data.code == 401) {
                message.error(res.data.msg);
                setTimeout(() => {
                    location.href = '/Login';
                }, 1000);
            }
        })
        .catch((err) => {
            fullscreenLoading.close();
            message.error(err);
        });
};

const WithdrawalPageChange = (page: number, pageSize: number) => {
    Withdrawal_Conf.value.currentPage = page;
    Withdrawal_Conf.value.pageSize = pageSize;
    getUserWithdrawal();
};

const applyWithdrawal = (act: string) => {
    if (act == 'dialog') {
        Withdrawal_Dialog.value.Visible = true;
        getSkm();
    } else if (act == 'apply') {
        const data = new FormData();

        if (isNull(Withdrawal_Dialog.value.from.money)) {
            message.error('请输入提现金额');
            return;
        }
        data.append('money', Withdrawal_Dialog.value.from.money);

        data.append('act', Withdrawal_Dialog.value.from.selectAct);
        const temp = Withdrawal_Dialog.value.from.skAct.filter(
            (item: any) => item.act == Withdrawal_Dialog.value.from.selectAct
        );
        if (temp.length == 0) {
            message.error('请选择收款信息');
            return;
        }

        data.append('skm', temp[0].skm);
        data.append('remarks', Withdrawal_Dialog.value.from.remarks);
        const headers = {
            token: localStorage.getItem('token'),
        };

        openLoading();
        axios
            .post(baseURL + '/userApi/applyWithdrawal', data, { timeout: 5000, headers })
            .then((res) => {
                fullscreenLoading.close();
                if (res.data.code == 401) {
                    message.error(res.data.msg);
                    setTimeout(() => {
                        location.href = '/login';
                    }, 1000);
                } else if (res.data.code == 200) {
                    message.success(res.data.msg);
                    Withdrawal_Dialog.value.Visible = false;
                    getUserWithdrawal();
                } else {
                    message.error(res.data.msg);
                }
            })
            .catch((err) => {
                fullscreenLoading.close();
                message.error(err);
            });
    }
};

// ============ 生命周期 ============
onMounted(() => {
    getUserWithdrawal();
});

return (_ctx: any,_cache: any) => {
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_layout, { style: {"min-height":"100vh"} }, {
      default: _withCtx(() => [
        _createVNode(UserHead),
        _createVNode(_component_a_layout, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_layout_header, { style: {"padding":"0","background":"#fff","border-bottom":"1px solid #f0f0f0"} }, {
              default: _withCtx(() => [
                _createVNode(HeadTop)
              ]),
              _: 1
            }),
            _createVNode(_component_a_layout_content, {
              class: "page-content",
              style: {"padding":"24px","background":"#f5f7fa"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_a_row, {
                    gutter: [16, 16],
                    class: "stat-row"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        xs: 24,
                        sm: 12,
                        md: 6
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_card, {
                            class: "stat-card",
                            bordered: false
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                  _createVNode(_unref(BankOutlined))
                                ]),
                                _createElementVNode("div", _hoisted_4, [
                                  _hoisted_5,
                                  _createElementVNode("div", _hoisted_6, _toDisplayString(Withdrawal_Conf.value.total), 1)
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        xs: 24,
                        sm: 12,
                        md: 6
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_card, {
                            class: "stat-card",
                            bordered: false
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                  _createVNode(_unref(ClockCircleOutlined))
                                ]),
                                _createElementVNode("div", _hoisted_9, [
                                  _hoisted_10,
                                  _createElementVNode("div", _hoisted_11, _toDisplayString(pendingCount.value), 1)
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        xs: 24,
                        sm: 12,
                        md: 6
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_card, {
                            class: "stat-card",
                            bordered: false
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                  _createVNode(_unref(CheckCircleOutlined))
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                  _hoisted_15,
                                  _createElementVNode("div", _hoisted_16, _toDisplayString(successCount.value), 1)
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        xs: 24,
                        sm: 12,
                        md: 6
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_card, {
                            class: "stat-card",
                            bordered: false
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("div", _hoisted_18, [
                                  _createVNode(_unref(CloseCircleOutlined))
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                  _hoisted_20,
                                  _createElementVNode("div", _hoisted_21, _toDisplayString(rejectedCount.value), 1)
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_card, {
                    bordered: false,
                    class: "table-card"
                  }, {
                    title: _withCtx(() => [
                      _createElementVNode("div", _hoisted_22, [
                        _hoisted_23,
                        _createVNode(_component_a_tag, { color: "blue" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(Withdrawal_Conf.value.total) + " 条", 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    extra: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (applyWithdrawal('dialog')))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(PlusOutlined))
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode("申请提现 ")
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_table, {
                        class: "withdrawal-table-pc",
                        "data-source": Withdrawal_data.value,
                        pagination: false,
                        "row-key": "id",
                        scroll: { x: 1100 },
                        size: "small",
                        loading: tableLoading.value,
                        bordered: "",
                        columns: withdrawalColumns
                      }, {
                        bodyCell: _withCtx(({ column, record }) => [
                          (column.key === 'money')
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass(['money-text', record.state == 1 ? 'money-success' : ''])
                              }, _toDisplayString(record.money) + " 元 ", 3))
                            : (column.key === 'skm')
                              ? (_openBlock(), _createBlock(_component_a_image, {
                                  key: 1,
                                  src: record.skm,
                                  width: "60",
                                  height: "60",
                                  style: {"border-radius":"6px"}
                                }, null, 8, ["src"]))
                              : (column.key === 'act')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    (record.act === 'wx')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                          _createVNode(_unref(WechatOutlined), { style: {"color":"#07c160"} }),
                                          _createTextVNode(" 微信 ")
                                        ]))
                                      : (record.act === 'zfb')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                            _createVNode(_unref(AlipayCircleOutlined), { style: {"color":"#1677ff"} }),
                                            _createTextVNode(" 支付宝 ")
                                          ]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(record.act || '未知'), 1))
                                  ], 64))
                                : (column.key === 'state')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                      (record.state == 0)
                                        ? (_openBlock(), _createBlock(_component_a_tag, {
                                            key: 0,
                                            color: "gold"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(ClockCircleOutlined)),
                                              _createTextVNode(" 等待审核 ")
                                            ]),
                                            _: 1
                                          }))
                                        : (record.state == 1)
                                          ? (_openBlock(), _createBlock(_component_a_tag, {
                                              key: 1,
                                              color: "green"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(CheckCircleOutlined)),
                                                _createTextVNode(" 已打款 ")
                                              ]),
                                              _: 1
                                            }))
                                          : (record.state == -1)
                                            ? (_openBlock(), _createBlock(_component_a_tag, {
                                                key: 2,
                                                color: "red"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(CloseCircleOutlined)),
                                                  _createTextVNode(" 已驳回 ")
                                                ]),
                                                _: 1
                                              }))
                                            : (_openBlock(), _createBlock(_component_a_tag, {
                                                key: 3,
                                                color: "default"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("未知")
                                                ]),
                                                _: 1
                                              }))
                                    ], 64))
                                  : (column.key === 'res_code')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                        (!_unref(isNull)(record.res_code))
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(record.res_code), 1))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_28, "无"))
                                      ], 64))
                                    : (column.key === 'end_time')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                          (!_unref(isNull)(record.end_time))
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(record.end_time), 1))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_30, "无"))
                                        ], 64))
                                      : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["data-source", "loading"]),
                      (Withdrawal_data.value && Withdrawal_data.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Withdrawal_data.value, (record) => {
                              return (_openBlock(), _createBlock(_component_a_card, {
                                key: record.id,
                                class: "withdrawal-mobile-card",
                                bordered: false
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_32, [
                                    _createElementVNode("div", _hoisted_33, [
                                      _createElementVNode("span", _hoisted_34, "#" + _toDisplayString(record.id), 1),
                                      (record.state == 0)
                                        ? (_openBlock(), _createBlock(_component_a_tag, {
                                            key: 0,
                                            color: "gold"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("等待审核")
                                            ]),
                                            _: 1
                                          }))
                                        : (record.state == 1)
                                          ? (_openBlock(), _createBlock(_component_a_tag, {
                                              key: 1,
                                              color: "green"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("已打款")
                                              ]),
                                              _: 1
                                            }))
                                          : (record.state == -1)
                                            ? (_openBlock(), _createBlock(_component_a_tag, {
                                                key: 2,
                                                color: "red"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("已驳回")
                                                ]),
                                                _: 1
                                              }))
                                            : (_openBlock(), _createBlock(_component_a_tag, {
                                                key: 3,
                                                color: "default"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("未知")
                                                ]),
                                                _: 1
                                              }))
                                    ]),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["money-text", record.state == 1 ? 'money-success' : ''])
                                    }, _toDisplayString(record.money) + " 元 ", 3)
                                  ]),
                                  _createElementVNode("div", _hoisted_35, [
                                    _createElementVNode("div", _hoisted_36, [
                                      _hoisted_37,
                                      _createElementVNode("span", _hoisted_38, [
                                        (record.act === 'wx')
                                          ? (_openBlock(), _createBlock(_unref(WechatOutlined), {
                                              key: 0,
                                              style: {"color":"#07c160"}
                                            }))
                                          : (record.act === 'zfb')
                                            ? (_openBlock(), _createBlock(_unref(AlipayCircleOutlined), {
                                                key: 1,
                                                style: {"color":"#1677ff"}
                                              }))
                                            : _createCommentVNode("", true),
                                        _createTextVNode(" " + _toDisplayString(record.act === 'wx' ? '微信' : record.act === 'zfb' ? '支付宝' : '未知'), 1)
                                      ])
                                    ]),
                                    (record.skm)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                          _hoisted_40,
                                          _createVNode(_component_a_image, {
                                            src: record.skm,
                                            width: "64",
                                            height: "64",
                                            style: {"border-radius":"6px"}
                                          }, null, 8, ["src"])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_41, [
                                      _hoisted_42,
                                      _createElementVNode("span", _hoisted_43, _toDisplayString(record.remarks || '无'), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_44, [
                                      _hoisted_45,
                                      _createElementVNode("span", _hoisted_46, _toDisplayString(record.res_code || '无'), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_47, [
                                      _hoisted_48,
                                      _createElementVNode("span", _hoisted_49, _toDisplayString(record.add_time), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_50, [
                                      _hoisted_51,
                                      _createElementVNode("span", _hoisted_52, _toDisplayString(record.end_time || '无'), 1)
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      ((!Withdrawal_data.value || Withdrawal_data.value.length === 0) && !tableLoading.value)
                        ? (_openBlock(), _createBlock(_component_a_empty, {
                            key: 1,
                            description: "暂无提现记录"
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_53, [
                        _createVNode(_component_a_pagination, {
                          current: Withdrawal_Conf.value.currentPage,
                          "onUpdate:current": _cache[1] || (_cache[1] = ($event: any) => ((Withdrawal_Conf.value.currentPage) = $event)),
                          "page-size": Withdrawal_Conf.value.pageSize,
                          "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((Withdrawal_Conf.value.pageSize) = $event)),
                          "page-size-options": [10, 25, 50],
                          disabled: tableLoading.value,
                          "show-size-changer": "",
                          "show-quick-jumper": "",
                          "show-total": (total) => `共 ${total} 条记录`,
                          total: Withdrawal_Conf.value.total,
                          onChange: WithdrawalPageChange
                        }, null, 8, ["current", "page-size", "disabled", "show-total", "total"])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      open: Withdrawal_Dialog.value.Visible,
      "onUpdate:open": _cache[8] || (_cache[8] = ($event: any) => ((Withdrawal_Dialog.value.Visible) = $event)),
      title: "申请提现",
      width: 540,
      "mask-closable": false,
      footer: null,
      centered: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: Withdrawal_Dialog.value.from,
          layout: "vertical"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "提现金额" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  max: Withdrawal_Dialog.value.maxMoney,
                  value: Withdrawal_Dialog.value.from.money,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((Withdrawal_Dialog.value.from.money) = $event)),
                  style: {"width":"100%"},
                  placeholder: '单笔提现范围:' + 0 + '--' + Withdrawal_Dialog.value.maxMoney
                }, null, 8, ["max", "value", "placeholder"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "选择收款方式" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: Withdrawal_Dialog.value.from.selectAct,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((Withdrawal_Dialog.value.from.selectAct) = $event)),
                  placeholder: "--请选择--"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Withdrawal_Dialog.value.from.skAct, (item, i) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: i,
                        value: item.act
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.str), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "备注" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  type: "textarea",
                  rows: 4,
                  value: Withdrawal_Dialog.value.from.remarks,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((Withdrawal_Dialog.value.from.remarks) = $event)),
                  placeholder: "请输入备注信息（选填）"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createElementVNode("div", _hoisted_54, [
          _createVNode(_component_a_button, {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (Withdrawal_Dialog.value.Visible = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("关闭")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (applyWithdrawal('apply')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("申请提现")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})